<template>
  <div>
    <b-button
      class="mb-1"
      variant="primary"
      @click="clearZone"
    >
      <span>Clear Zone</span>
    </b-button>
    <div id="zoneMap" />
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import {
  reactive, ref, onMounted,
} from '@vue/composition-api'

export default {
  components: {
    BButton,
  },
  props: {
    polygon: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, ctx) {
    const paths = ref([])
    let map = null
    const mapCenter = reactive({
      lat: 31.963158, lng: 35.930359,
    })
    // eslint-disable-next-line no-undef
    const polygon = new google.maps.Polygon({
      paths: [
        props.polygon,
      ],
      editable: true,
    })
    function clearZone() {
      paths.value = []
      ctx.emit('zones-set', paths.value)
      polygon.setPaths(paths.value)
    }
    function initMap() {
      // eslint-disable-next-line no-undef
      map = new google.maps.Map(document.getElementById('zoneMap'), {
        zoom: 10,
        center: mapCenter,
      })
      map.setOptions({ draggableCursor: 'crosshair' })
      map.addListener('click', e => {
        paths.value.push(e.latLng.toJSON())
        polygon.setPaths(paths.value)
        ctx.emit('zones-set', paths.value)
      })
      polygon.setMap(map)
    }
    onMounted(() => {
      initMap()
    })
    return {
      clearZone,
    }
  },
}

</script>

<style scoped>
#zoneMap {
  width: 100%;
  height: 400px;
}
</style>
